import { render, staticRenderFns } from "./NewTool.vue?vue&type=template&id=738d3e24&scoped=true"
import script from "./NewTool.vue?vue&type=script&lang=ts"
export * from "./NewTool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738d3e24",
  null
  
)

export default component.exports